import {
  getPlayerBalance,
  listGameHolds,
  listPlayerHistory,
  listPlayerOperations,
} from "./balances";
import { claimCredits } from "./credits";
import { getEarningsStatus, listDailyEarnings } from "./earnings";
import { listPlayerOpenHolds } from "./holds";
import { closePlayer } from "./players";
import { getLedgerReport } from "./reports";
import { createSupportAdjustment, listSupportAdjustments } from "./support";

export {
  BalanceRequestHeaders,
  BalanceResponse,
  BucketAmounts,
  BucketBalances,
  CallAgent,
  ChargedModelCall,
  ClaimCreditRefreshResponse,
  ClaimCreditsResponse,
  ClientAllowance,
  ClosePlayerRequest,
  ClosePlayerResponse,
  CreateSupportAdjustmentResponse,
  CreditChange,
  CreditHistoryQuery,
  CreditHistoryResponse,
  CreditJournal,
  EARNINGS_RANGE_DAYS,
  EarningsByDayPart,
  EarningsByDayResponse,
  EarningsDay,
  EarningsDayTotal,
  EarningsQuery,
  EarningsRange,
  EarningsStatus,
  GameHold,
  GameHoldOutcomeFilter,
  GameHoldsQuery,
  GameHoldsResponse,
  GameParams,
  HeldFor,
  HOLD_OUTCOME_MEANINGS,
  HoldId,
  HoldKind,
  HoldOutcome,
  HoldRequestId,
  HoldStatus,
  JournalTotal,
  LedgerPerson,
  LedgerReportName,
  LedgerReportParams,
  LedgerReportQuery,
  LedgerReportRange,
  LedgerReportResponse,
  ListSupportAdjustmentsQuery,
  ListSupportAdjustmentsResponse,
  MAX_PERIODS_BACK,
  MAX_SUPPORT_ISSUANCE_CREDITS_PER_DAY,
  OpenHold,
  OpenHoldsResponse,
  OperationEntry,
  OperationId,
  OperationPosting,
  PlayerBucket,
  PlayerHistoryCut,
  PlayerHistoryItem,
  PlayerOperation,
  PlayerOperationsQuery,
  PlayerOperationsResponse,
  RawPaxAmount,
  RawPaxQuantity,
  RawPaxSum,
  RawPaxTotal,
  RELEASE_REASON_MEANINGS,
  RecordedCreditChange,
  RefreshEligibility,
  ReleasedHold,
  ReleaseReason,
  SignedRawPaxSum,
  SignupBudgetSpentData,
  SUPPORT_NOTE_MAX_CHARACTERS,
  SupportAdjustment,
  SupportAdjustmentDirection,
  SupportAdjustmentReason,
  SupportAdjustmentRequest,
  SystemAccountFlow,
  SystemAccountKind,
  UserParams,
} from "./schemas";
export { service } from "./service";

export const contract = {
  players: {
    balances: { get: getPlayerBalance },
    history: { list: listPlayerHistory },
    openHolds: { list: listPlayerOpenHolds },
    earningsStatus: { get: getEarningsStatus },
    operations: { list: listPlayerOperations },
    close: { create: closePlayer },
  },
  games: {
    holds: { list: listGameHolds },
  },
  dailyEarnings: { list: listDailyEarnings },
  reports: { get: getLedgerReport },
  credits: { claim: claimCredits },
  support: {
    adjustments: { list: listSupportAdjustments, create: createSupportAdjustment },
  },
} as const;

export {
  CLIENT_FREE_ALLOWANCE_RAW,
  CLIENT_FREE_ALLOWANCE_WINDOW_HOURS,
  playerBucketFromSql,
  playerBucketToSql,
  RAW_PAX_CREDITS_PER_DISPLAY_CREDIT,
  REFRESH_PERSON_REQUIRED_AFTER_DAYS,
  sortBucketMap,
  sourceIds,
} from "../shared";
